<style lang="scss" scoped>
.back {
    cursor: pointer;
}
::v-deep .slideXLeftIn {
    pointer-events: none;
    &.extra-menu {
        animation-name: slideXRightIn !important;
    }
}
</style>

<template>
    <div class="h-100 d-flex flex-column">
        <div class="d-flex justify-content-start align-items-center">
            <a
                :href="route('nl.home')"
                class="home-link mr-auto font-weight-light link-white px-24 py-16"
                ><strong>InspireYourTribe</strong>.be</a
            >
            <mobile-search></mobile-search>
            <hamburger-button></hamburger-button>
        </div>

        <slide-x-left-transition
            :duration="{ enter: 300, leave: 0 }"
            mode="out-in"
        >
            <div
                class="d-flex flex-column flex-grow-1 justify-content-between"
                v-if="!extraOpen"
                key="menu"
            >
                <div class="container my-auto">
                    <div class="row">
                        <div
                            class="col-12 d-flex flex-column justify-content-center align-items-start"
                        >
                            <a
                                v-for="route in routes"
                                :href="route.pagina.url"
                                class="mb-32 link-white lh-34"
                                :class="
                                    currentlyViewing(route.pagina.url)
                                        ? 'font-weight-normal'
                                        : 'font-weight-light'
                                "
                                :key="route.pagina.title"
                                >{{ route.pagina.title }}</a
                            >
                            <!--<menu-extra-dropdown class="link-white lh-34 mb-32" :label="extraLabel" :landing-pages="landingPages" :open="extraOpen" @change="value => extraOpen = value"></menu-extra-dropdown>-->
                        </div>
                    </div>
                </div>
                <div class="container">
                    <div class="row mb-24">
                        <div class="col-12">
                            <p class="text-white font-weight-light mb-16">
                                Powered by
                            </p>
                            <a
                                href="https://www.tothepointevents.be/"
                                target="_blank"
                                rel="noopener"
                            >
                                <h3>
                                    <img
                                        class="logo"
                                        src="/svg/to-the-point-events-logo.svg"
                                        alt="To The Point Events."
                                    /><span class="sr-only"
                                        >To The Point Events.</span
                                    >
                                </h3>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="container my-auto overflow-auto extra-menu"
                v-if="extraOpen"
                key="extra"
            >
                <div class="row">
                    <div
                        class="col-12 d-flex flex-column justify-content-center align-items-start"
                    >
                        <div
                            class="d-inline text-accent small back"
                            @click="extraOpen = false"
                        >
                            <i class="fas fa-arrow-left mr-8 mb-32"></i
                            ><span>Terug</span>
                        </div>
                        <menu-extra-dropdown
                            class="link-white lh-34 mb-32"
                            :label="extraLabel"
                            :landing-pages="landingPages"
                            :open="extraOpen"
                            @change="value => (extraOpen = value)"
                        ></menu-extra-dropdown>
                    </div>
                </div>
            </div>
        </slide-x-left-transition>
    </div>
</template>

<script>
export default {
    props: {
        routes: {
            type: Array,
            default: () => []
        },
        extraLabel: {
            type: String,
            required: true
        },
        landingPages: {
            type: Array,
            default: () => []
        }
    },

    data: () => ({
        extraOpen: false,
        showFooter: true
    }),

    watch: {
        "$root.navigationIsVisble": {
            handler: function() {
                this.extraOpen = false;
            }
        }
    },

    methods: {
        currentlyViewing(url) {
            return this.$route.path.includes(url);
        }
    }
};
</script>
